import { createSlice } from '@reduxjs/toolkit';

export const STATE_INIT = 'STATE_INIT';
export const STATE_LOADING = 'STATE_LOADING';
export const STATE_SUCCESS = 'STATE_SUCCESS';
export const STATE_FAILED = 'STATE_FAILED';

const initialState = {
  items: [],
  state: STATE_INIT,
};

const clientOrdersSlice = createSlice({
  name: 'clients',
  initialState,
  reducers: {
    loadClientsStarted(state) {
      return {
        ...state,
        state: STATE_LOADING,
      };
    },
    loadClientsSuccess(state, { payload: items }) {
      return {
        ...state,
        items,
        state: STATE_SUCCESS,
      };
    },
    loadClientsFailed(state) {
      return {
        ...state,
        state: STATE_FAILED,
      };
    },
    updateClient(state, { payload: updatedItem }) {
      return {
        ...state,
        items: state.items.map((item) => {
          return item.id === updatedItem.id ? updatedItem : item;
        }),
      };
    },
    resetClients() {
      return { ...initialState };
    },
  },
});

export const { loadClientsStarted, loadClientsSuccess, loadClientsFailed, updateClient, resetClients } =
  clientOrdersSlice.actions;

export default clientOrdersSlice.reducer;
